import { services } from "@/lib/studio";
import { ArrowUpRight, ArrowRight } from "lucide-react";

export default function Services() {
  return (
    <section id="services" className="relative py-8 md:py-12 px-5 md:px-8" data-testid="services-section">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <div>
            <div className="text-[10px] tracking-[0.34em] uppercase text-olive font-semibold mb-4">
              · What we do
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-medium tracking-tighter text-cream leading-[1]">
              Two crafts.
              <br />
              <span className="italic font-light font-shadows text-3xl md:text-4xl lg:text-5xl">ONE OBSESSION</span>
            </h2>
          </div>
          <p className="text-cream/60 max-w-sm text-sm leading-relaxed">
            Every visit begins with a real conversation — no pressure, no upselling. Only then do we pick up a needle.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 md:gap-8">
          {services.map((s) => (
            <div
              key={s.key}
              className="group relative flex flex-col md:flex-row overflow-hidden rounded-[2rem] border border-olive/30 hover:border-olive bg-ink/60 transition-all"
              data-testid={`service-card-${s.key}`}
            >
              {/* Image area — 40% on desktop, vertical stack on mobile */}
              <a
                href="#final-cta"
                aria-label={`Book ${s.title}`}
                className="relative shrink-0 w-full md:w-[40%] h-48 md:h-auto flex items-center justify-center border-b md:border-b-0 md:border-r border-olive/20 bg-gradient-to-br from-olive/10 via-ink to-ink overflow-hidden"
              >
                <div className="absolute inset-0 opacity-[0.06] bg-[radial-gradient(circle_at_center,_theme(colors.cream)_1px,_transparent_1px)] [background-size:14px_14px]" />
                <img
                  src={s.image}
                  alt={s.title}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </a>

              {/* Content — 60% on desktop */}
              <div className="flex-1 md:w-[60%] min-w-0 flex flex-col p-6 md:p-8 lg:p-10">
                <a
                  href="#final-cta"
                  className="flex items-start justify-between gap-3 mb-2 md:mb-4 min-h-[2.4em] sm:min-h-[2.5em] md:min-h-[2.4em]"
                >
                  <h3 className="font-display text-lg sm:text-2xl md:text-3xl font-medium tracking-tight text-cream leading-tight line-clamp-2">
                    {s.title}
                  </h3>
                  <div className="h-8 w-8 md:h-10 md:w-10 border border-olive/40 group-hover:border-olive group-hover:bg-olive/10 flex items-center justify-center shrink-0 transition-all">
                    <ArrowUpRight
                      size={15}
                      className="text-cream transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                      strokeWidth={1.6}
                    />
                  </div>
                </a>

                <p className="text-cream/65 text-xs sm:text-sm leading-relaxed mb-3 md:mb-6 line-clamp-2 min-h-[2.5em]">
                  {s.description}
                </p>

                <div className="flex flex-wrap gap-1.5 md:gap-2 mb-4 md:mb-0 min-h-[26px] sm:min-h-[32px]">
                  {s.points.map((p) => (
                    <span
                      key={p}
                      className="text-[8px] sm:text-[10px] tracking-[0.18em] sm:tracking-[0.22em] uppercase text-olive border border-olive/30 px-2 sm:px-3 py-1 sm:py-1.5"
                    >
                      {p}
                    </span>
                  ))}
                </div>

                {s.key === "piercing" && (
                  <div className="mt-4 md:mt-6 px-4 py-3 bg-olive/5 border-l-2 border-olive text-cream/70 text-xs leading-relaxed italic">
                    <span className="font-semibold not-italic text-olive block mb-0.5">Jewellery Gallery — Coming Soon.</span>
                    Browse our complete online collection of implant-grade titanium pieces.
                  </div>
                )}

                <a
                  href="#final-cta"
                  className="mt-auto sm:mt-8 inline-flex w-full sm:w-auto items-center justify-center gap-2 bg-olive hover:bg-olive-hover text-cream px-4 sm:px-6 py-2.5 sm:py-3 text-[10px] sm:text-[11px] tracking-[0.24em] uppercase font-medium transition-all"
                  data-testid={`service-book-btn-${s.key}`}
                >
                  Book Consultation
                  <ArrowRight size={13} className="transition-transform group-hover:translate-x-1" strokeWidth={1.8} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
